const userCellHeaders = [
    { id: 'name', label: 'Name', align: 'left', width: 180, minWidth: 120 },
    { id: 'company', label: 'Company', align: 'left', width: 200, minWidth: 150 },
    { id: 'role', label: 'Role', align: 'left', width: 150, minWidth: 100 },
    { id: 'isVerified', label: 'Verified', align: 'left', width: 120, minWidth: 100 },
    { id: 'status', label: 'Status', align: 'left', width: 120, minWidth: 100 },
    { id: '' }
  ];
  
export default userCellHeaders;